import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=520f5862&scoped=true"
import script from "./pdfView.vue?vue&type=script&lang=js"
export * from "./pdfView.vue?vue&type=script&lang=js"
import style0 from "./pdfView.vue?vue&type=style&index=0&id=520f5862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f5862",
  null
  
)

export default component.exports